import { BASE_URL, DEVICE_TYPE, USER_TYPE } from '../../config'
import { SET_ERROR_STATE, RESET_STATUS_STATE, REQUEST_STATE } from '../../utils/constants/actionTypes';
import history from '../../history';
import publicIp from 'public-ip';
import {SLogin} from '../../config/api'
import bugsnagClient from '../../config/bugsnag';

export default ( data ) => async (dispatch) => {
	dispatch({ type: RESET_STATUS_STATE});
	dispatch({ type : REQUEST_STATE });
	
	try{
		let res = await fetch(`${BASE_URL}${SLogin}`, {
					method : 'POST',
					credentials: 'include',
					headers : {
						'X-User-ID' 		: data.email,
						'X-User-Password' 	: data.password,
						'X-Device-Type' 	: DEVICE_TYPE,
						'X-User-Type'		: USER_TYPE,
						'X-Device-IP'		: await publicIp.v4(),
						'X-Device-Name'		: 'No Information',
						'Content-Type' 		: "application/json",
					},
					body: JSON.stringify({})
				})
		let hasil = await res.json()
		if( res.status === 200 ){
			history.replace('/')
			window.location.reload();
		} else{
			console.log(hasil.status.message)
			dispatch({ type: SET_ERROR_STATE, payload : hasil.status.message })
			bugsnagClient.notify(new Error(`Login.js/ (line 33) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch(err){
		dispatch({ type: SET_ERROR_STATE, payload : err.message })
		bugsnagClient.notify(new Error(`Login.js/ (line 37) ===> catch - ${err.message}`))
	}
}